import { render, staticRenderFns } from "./ProductAddonSingle.vue?vue&type=template&id=6a452d65&scoped=true&"
import script from "./ProductAddonSingle.vue?vue&type=script&lang=js&"
export * from "./ProductAddonSingle.vue?vue&type=script&lang=js&"
import style0 from "./ProductAddonSingle.vue?vue&type=style&index=0&id=6a452d65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a452d65",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRadio,VRadioGroup,VRow})
